export function VerticalDivider() {
  return (
    <div style={{ paddingTop: '1px' }}>
      <div style={{ borderLeft: '1px solid #d9d9d9', width: '1px', height: '16px' }} />
    </div>
  );
}
